export default __webpack_public_path__ + "static/richmond_bg_planet-35cc3437325cab24ed7c82c40eec5c40.jpeg";